import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ItemFoundInfoStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  max-width: 100%;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  background-color: ${theme.colors.ion.primary.onstronger};
  border-radius: ${theme.shapes.borderRadius.md};

  svg {
    path {
      fill: ${theme.colors.ion.primary.main};
    }
  }

  #NoItemFoundTitle {
    text-align: center;
    font-family: ${theme.typography.family.primary};
    margin: ${theme.spacing.xs} 0;
    font-size: ${theme.typography.sizes.md};
    font-weight: ${theme.typography.weight.md};
    color: ${theme.colors.ion.primary.main};
  }

  #NoItemFoundDescription {
    text-align: center;
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.sm};
    color: ${theme.colors.ion.neutral.stronger};
  }
`
